console.log("Infinite scroll active.");

function updateProductCount() {
    // Query
    const progressElement = document.querySelector('.item-counter-progress');
    const progressLine = document.querySelector('.item-counter-progress-line');
    const pageCountText = document.querySelector('.page-count-text');
    const pageCountContainer = document.querySelector('.page-count-container');
    const viewMoreButton = document.querySelector('.view-more-button');
    const productBlocks = document.querySelectorAll('.js-grid > .infinitescroll-item').length;
    const itemCounter = document.querySelector('.item-counter');
    
    // Safety check - if elements don't exist, exit
    if (!progressElement || !itemCounter) {
        console.log("Required elements not found");
        return;
    }
    
    // Update counter and progress
    itemCounter.textContent = productBlocks;
    progressElement.value = productBlocks;
    
    if (progressLine) {
        progressLine.style.width = `${(progressElement.value / progressElement.max) * 100}%`;
    }
    
    // Check if we're on the last page (no more pages to load)
    const nextLink = document.querySelector('.pagination-custom__next');
    const noNext = nextLink ? nextLink.getAttribute('data-no-next') : null;
    const nextHref = nextLink ? nextLink.getAttribute('href') : null;
    const isLastPage = noNext || !nextHref || nextHref === '#' || nextHref === '';
    
    // Hide button if all items are loaded OR we're on the last page
    if (progressElement.value >= progressElement.max || isLastPage) {
        if (viewMoreButton) {
            viewMoreButton.hidden = true;
            viewMoreButton.style.display = "none";
        }
        console.log("Show More button hidden - Last page:", isLastPage, "All loaded:", progressElement.value >= progressElement.max);
    } else {
        // Show button if more items to load
        if (viewMoreButton) {
            viewMoreButton.hidden = false;
            viewMoreButton.style.display = "block";
        }
    }
    
    console.log(`Product count updated: ${productBlocks} / ${progressElement.max}`);
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
    console.log("DOM loaded, initializing infinite scroll");
    
    // Run initial count update
    updateProductCount();
    
    // Watch for changes in the product-grid container
    const productGrid = document.querySelector('.js-grid');
    if (productGrid) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    console.log("Product grid changed");
                    updateProductCount();
                }
            });
        });
        
        observer.observe(productGrid, { childList: true, subtree: true });
        console.log("Observer attached to product grid");
    } else {
        console.log("Product grid not found");
    }
    
    // Also watch for changes in pagination (when next link appears/disappears)
    const paginationContainer = document.querySelector('.collection__pagination');
    if (paginationContainer) {
        const paginationObserver = new MutationObserver(function(mutations) {
            console.log("Pagination changed, updating count");
            updateProductCount();
        });
        
        paginationObserver.observe(paginationContainer, { 
            childList: true, 
            subtree: true, 
            attributes: true,
            attributeFilter: ['href', 'data-no-next', 'style']
        });
        console.log("Observer attached to pagination");
    }
    
    // Initialize Infinite Scroll only if next link exists and has valid href
    const scrollList = document.querySelector("[data-infinite-scroll]");
    const nextLink = document.querySelector('.pagination-custom__next');
    
    if (scrollList && nextLink) {
        const nextHref = nextLink.getAttribute('href');
        const noNext = nextLink.getAttribute('data-no-next');
        
        // Only initialize if href is valid (not #, empty, or marked as no-next)
        if (nextHref && nextHref !== '#' && nextHref !== '' && !noNext) {
            try {
                const InfScroll = InfiniteScroll(scrollList);
                
                InfScroll.on('append', function(body, path, items, response) {
                    console.log("Items appended via infinite scroll");
                    
                    // Re-initialize any widgets on new items
                    document.querySelectorAll('[data-oke-star-rating]').forEach(elem => {
                        if (window.okeWidgetApi) {
                            window.okeWidgetApi.initWidget(elem);
                        }
                    });
                    
                    // Update count after append
                    updateProductCount();
                });
                
                InfScroll.on('last', function(body, path) {
                    console.log("Reached last page of infinite scroll");
                    updateProductCount();
                });
                
                console.log("Infinite scroll initialized with next link:", nextHref);
            } catch (error) {
                console.log("Infinite scroll initialization error:", error);
            }
        } else {
            console.log("Infinite scroll not initialized - invalid or missing next page. href:", nextHref, "noNext:", noNext);
        }
    } else {
        console.log("Infinite scroll not initialized - scrollList:", !!scrollList, "nextLink:", !!nextLink);
    }
});